// 部品 ボタン左右揃え用棚
import React from 'react';
import { Row, Col } from 'react-bootstrap';

interface Props {
  children: React.ReactNode;
}

const RowLeftAndRightAlignmentButton: React.FC<Props> = ({ children }) => {
  return (
    <Row className="row-left-and-right-alignment-buttons">
      <Col className="text-start-and-right">{children}</Col>
    </Row>
  );
};

export default RowLeftAndRightAlignmentButton;
